import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@capturum/formly';
import { RouterModule } from '@angular/router';
import { TenantFormComponent } from './components/tenant-form/tenant-form.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    TenantFormComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    FormModule,
    ReactiveFormsModule,
  ],
  exports: [
    TenantFormComponent,
  ],
})

export class TenantModule {
}
